import PayrollCompaniesPage from './PayrollCompaniesPage';
export default PayrollCompaniesPage;